module.exports = __webpack_public_path__ + "static/media/before_translate.18d38a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/img/before_translate.png
// module id = 179
// module chunks = 0